<template>
	<div class="wrap">
		<div class="no-data">
			<img src="~images/nodata.png" />
			<p>{{ content }}</p>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			content: {
				type: String,
				default: '暂无数据'
			}
		},
		mounted() {
			this.$nextTick(() => {
				if(this.$el) {
					this.$el.parentNode.style.position = 'relative'
				}
			})
		}
	}
</script>

<style scoped lang="scss">
	.wrap {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.no-data {
		> img {
			width: 120px;
		}
		> p {
			height: 30px;
			line-height: 40px;
			text-align: center;
			color: #999;
			font-size: 14px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/nodata/NoData.vue